import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetOrderResultEffect } from './get-order-result.effect';
import { getOrderResultReducer } from './get-order-result.reducer';
import { GET_ORDER_RESULT_STORE_NAME, GetOrderResultState } from './get-order-result.state';

/** Token of the GetOrderResult reducer */
export const GET_ORDER_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetOrderResultState, Action>>(
  'Feature GetOrderResult Reducer'
);

/** Provide default reducer for GetOrderResult store */
export function getDefaultGetOrderResultReducer() {
  return getOrderResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_ORDER_RESULT_STORE_NAME, GET_ORDER_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetOrderResultEffect]),
  ],
  providers: [{ provide: GET_ORDER_RESULT_REDUCER_TOKEN, useFactory: getDefaultGetOrderResultReducer }],
})
export class GetOrderResultStoreModule {
  public static forRoot<T extends GetOrderResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetOrderResultStoreModule> {
    return {
      ngModule: GetOrderResultStoreModule,
      providers: [{ provide: GET_ORDER_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
